var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_c('div',[_c('router-view',{attrs:{"testator":_vm.testator,"people-relations":_vm.peopleRelations}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }